import { SVGProps } from 'react';

export const LogoHorizontalIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="280"
      height="185"
      viewBox="0 0 280 185"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24.6204 184.494C15.9771 184.494 6.94086 182.136 0 178.077L5.76222 166.683C11.3935 169.957 17.8105 172.445 25.0133 172.445C31.1684 172.445 34.4424 170.612 34.4424 166.814C34.4424 164.326 33.1328 162.492 28.0254 160.004L17.0247 154.635C7.85757 150.313 4.32167 144.158 4.32167 137.217C4.32167 126.086 12.5721 120.062 25.799 120.062C32.7399 120.062 40.3356 121.895 46.7526 124.776L41.5142 135.908C36.9306 133.943 31.2994 131.979 25.4062 131.979C19.7749 131.979 17.9415 133.812 17.9415 136.562C17.9415 139.444 19.644 141.277 24.8823 143.765L36.1449 149.135C44.0024 152.801 48.1931 158.04 48.1931 166.159C48.1931 178.47 38.7641 184.494 24.6204 184.494Z"
        fill="#A9D0CD"
      />
      <path
        d="M90.0112 132.896H77.701V164.588C77.701 168.91 79.5344 170.874 83.9871 170.874H87.1301V182.66H81.2369C70.6292 182.66 64.867 177.029 64.867 167.076V132.896H54.1283V122.026H64.867V97.7984H77.701V122.026H90.0112V132.896Z"
        fill="#A9D0CD"
      />
      <path
        d="M128.391 120.062C147.38 120.062 161.523 133.681 161.523 152.278C161.523 170.874 147.38 184.494 128.391 184.494C109.401 184.494 95.2578 170.874 95.2578 152.278C95.2578 133.681 109.401 120.062 128.391 120.062ZM128.391 132.634C116.866 132.634 108.878 140.36 108.878 152.278C108.878 164.195 116.866 171.922 128.391 171.922C139.915 171.922 147.904 164.195 147.904 152.278C147.904 140.36 139.915 132.634 128.391 132.634Z"
        fill="#A9D0CD"
      />
      <path
        d="M208.722 120.193V135.253H206.758C194.185 135.253 187.507 141.277 187.507 155.683V182.529H174.673V122.026H187.507V135.253H187.768C190.65 126.217 197.59 120.193 207.805 120.193H208.722Z"
        fill="#A9D0CD"
      />
      <path
        d="M242.862 120.062C261.327 120.062 271.804 132.765 271.804 152.278V154.373H224.92C225.444 165.112 232.909 172.183 243.254 172.183C253.207 172.183 258.839 165.636 261.851 161.576L270.887 170.088C266.434 176.243 258.446 184.494 243.516 184.494C224.265 184.494 211.955 171.529 211.955 152.409C211.955 134.074 223.479 120.062 242.862 120.062ZM242.076 131.848C233.432 131.848 227.146 136.301 225.575 145.075H257.922C257.398 136.693 251.243 131.848 242.076 131.848Z"
        fill="#A9D0CD"
      />
      <path
        d="M44.0024 47.6693H31.5613V65.8727C31.5613 71.504 33.0018 73.3374 38.1093 73.3374H40.3356V91.6717H32.0851C19.7749 91.6717 11.7864 85.7786 11.7864 71.242V47.6693H0V31.1684H11.7864V6.94086H31.5613V31.1684H44.0024V47.6693Z"
        fill="#282828"
      />
      <path
        d="M93.5451 29.335V49.1099H91.8426C78.6157 49.1099 73.2464 53.9554 73.2464 69.4086V91.6717H53.4714V31.1684H72.8535V43.4786H73.1154C76.6513 33.5257 83.5922 29.335 93.1522 29.335H93.5451Z"
        fill="#282828"
      />
      <path
        d="M181.852 31.1684H201.365L179.364 91.6717H162.47L149.112 56.3126L135.885 91.6717H118.991L96.859 31.1684H116.503L127.765 66.6585L140.076 31.1684H158.279L170.589 66.6585L181.852 31.1684Z"
        fill="#282828"
      />
      <path d="M227.93 0V91.6717H208.155V0H227.93Z" fill="#282828" />
    </svg>
  );
};
